module.exports = __webpack_public_path__ + "img/homepage-content-over-image-showcase.ead78d92.png";